import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { forwardRef } from "react";
import { cn } from "@/lib/cn";

/**
 * Reemplazo de `<Tooltip>` de Mantine (Radix UI) · mismo default de
 * `openDelay: 300` + `withArrow` del tema (`mantine-theme.ts`).
 *
 * `TooltipProvider` se monta UNA vez en `__root.tsx` (junto a `Toaster`)
 * para compartir el delay entre todos los tooltips de la app — no hace
 * falta envolver cada uso.
 */
export const TooltipProvider = TooltipPrimitive.Provider;
export const Tooltip = TooltipPrimitive.Root;
export const TooltipTrigger = TooltipPrimitive.Trigger;

export const TooltipContent = forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, sideOffset = 6, children, ...props }, ref) => (
  <TooltipPrimitive.Portal>
    <TooltipPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      className={cn(
        "z-[1100] rounded-sm border border-border bg-ink-800 px-2 py-1 text-xs text-white shadow-md",
        "dark:bg-ink-100 dark:text-ink-900",
        "data-[state=delayed-open]:animate-fade-in",
        className
      )}
      {...props}
    >
      {children}
      <TooltipPrimitive.Arrow className="fill-ink-800 dark:fill-ink-100" />
    </TooltipPrimitive.Content>
  </TooltipPrimitive.Portal>
));
TooltipContent.displayName = "TooltipContent";
